import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Json',
    component: () => import('@/page/json/index'),
    meta: {
      title: 'JSON在线解析'
    }
  },
  {
    path: '/encryption',
    name: 'Encryption',
    component: () => import('@/components/nav/index'),
    meta: {
      title: '加/解密工具'
    },
    redirect: '/encryption/md5',
    children: [
      {
        path: 'md5',
        name: 'MD5',
        component: () => import('@/page/encryption/md5.vue'),
        meta: {
          title: 'MD5加密'
        }
      },
      {
        path: 'sha',
        name: 'SHA',
        component: () => import('@/page/encryption/sha.vue'),
        meta: {
          title: 'SHA加密'
        }
      },
      {
        path: 'desAes',
        name: 'DesAes',
        component: () => import('@/page/encryption/desAes.vue'),
        meta: {
          title: 'DES/AES加密解密'
        }
      },
      {
        path: 'rsa',
        name: 'Rsa',
        component: () => import('@/page/encryption/rsa.vue'),
        meta: {
          title: 'RSA公钥私钥加密解密'
        }
      }
    ]
  },
  {
    path: '/code',
    name: 'Code',
    component: () => import('@/components/nav/index'),
    meta: {
      title: '编码转换'
    },
    redirect: '/code/base64',
    children: [
      {
        path: 'base64',
        name: 'Base64',
        component: () => import('@/page/code/base64.vue'),
        meta: {
          title: 'BASE64编码转换'
        }
      },
      {
        path: 'url',
        name: 'Url',
        component: () => import('@/page/code/url.vue'),
        meta: {
          title: 'URL编码/解码'
        }
      },
      {
        path: 'unicode',
        name: 'Unicode',
        component: () => import('@/page/code/unicode.vue'),
        meta: {
          title: 'Unicode中文互换'
        }
      }
    ]
  },
  {
    path: '/date',
    name: 'Date',
    component: () => import('@/components/nav/index'),
    redirect: '/date/stamp',
    meta: {
      title: '时间转换'
    },
    children: [
      {
        path: 'stamp',
        name: 'Stamp',
        component: () => import('@/page/date/stamp.vue'),
        meta: {
          title: '时间戳转换'
        }
      },
      {
        path: 'calculation',
        name: 'Calculation',
        component: () => import('@/page/date/calculation.vue'),
        meta: {
          title: '日期计算'
        }
      }
    ]
  },
  {
    path: '/parse',
    name: 'Parse',
    component: () => import('@/components/nav/index'),
    meta: {
      title: '格式化/压缩工具',
    },
    redirect: '/parse/js',
    children: [
      {
        path: 'js',
        name: 'Js',
        component: () => import('@/page/parse/js.vue'),
        meta: {
          title: 'JavaScript格式化/压缩工具'
        }
      },
      {
        path: 'html',
        name: 'Html',
        component: () => import('@/page/parse/html.vue'),
        meta: {
          title: 'HTML格式化/压缩工具'
        }
      },
      {
        path: 'css',
        name: 'Css',
        component: () => import('@/page/parse/css.vue'),
        meta: {
          title: 'CSS格式化/压缩工具'
        }
      },
      {
        path: 'sql',
        name: 'Sql',
        component: () => import('@/page/parse/sql.vue'),
        meta: {
          title: 'SQL格式化/压缩工具'
        }
      }
    ]
  },
  {
    path: '/change',
    name: 'Change',
    component: () => import('@/components/nav/index'),
    meta: {
      title: '常用转换工具'
    },
    redirect: '/change/huoxingwen',
    children: [
      {
        path: 'hexbin',
        name: 'Hexbin',
        component: () => import('@/page/change/hexbin.vue'),
        meta: {
          title: '常用进制转换'
        }
      },
      {
        path: 'huoxingwen',
        name: 'Huoxingwen',
        component: () => import('@/page/change/huoxingwen.vue'),
        meta: {
          title: '简繁火星文转换'
        }
      },
      {
        path: 'pinyin',
        name: 'Pinyin',
        component: () => import('@/page/change/pinyin.vue'),
        meta: {
          title: '汉字转拼音'
        }
      },
      {
        path: 'rmb',
        name: 'Rmb',
        component: () => import('@/page/change/rmb.vue'),
        meta: {
          title: '数字转人民币大写'
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error404',
    component: () => import('@/page/error/404'),
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export {
  routes,
  router
}
